<template>
  <footer class="content-footer" :class="currentStyle">
    <div class="name">一般社団法人&nbsp;秋田県医師会</div>
    <address>〒010-0874&nbsp;秋田県秋田市千秋久保田町6番6号(秋田県総合保健センター4階)&nbsp;TEL:018-833-7401(代)</address>
    <nav>
      <ul class="footer-menu">
        <li><a href="http://www.akita.med.or.jp/">HOME</a></li>
        <li class="splitter"></li>
        <li><router-link to="/narrativebook_akita/social_media_policy">ソーシャルメディアポリシー</router-link></li>
      </ul>
    </nav>
    <p>Copyright © 2024 一般社団法人 秋田県医師会 | Akita Medical Association All Rights Reserved.</p>
  </footer>
</template>
<script>
  export default {
    name: 'CocoNarrativeFooter',
  
    props: {
      currentStyle: String
    },
  }
</script>

<style lang="scss" scoped>
@import '~@/assets/css/color_table.scss';
@import '~@/assets/css/media_query.scss';

footer.content-footer {
  padding: 20px 0;
  border-top: 1px solid $content-text-color;
  text-align: center;
  font-size: 13px;
  address {
    font-size: 11px;
    font-style: normal;
  }
  nav {
    display: flex;
    justify-content: center;
    ul.footer-menu {
      margin: 0 auto;
      display: flex;
      align-items: center;
      margin: 0;
      padding: 0;
      list-style-type: none;
      margin-block-start: 0;
      margin-inline-start: 0;
      li {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 6px;
        // width: 100px;
        height: 26px;
        font-size: 11px;
        text-align: center;
        &.splitter {
          width: 1px;
          height: 26px;
          margin: 0;
          border-left: 1px solid $content-text-color;
        }
        a {
          color: $content-text-color;
          text-decoration: none;
        }
      }
    }
  }
  &.nb_akita {
    background-color: $frame-background-color;
    color: $content-text-color;
  }
  &.care_narrative {
    background-color: $frame-background-color;
    color: $care-text-color;
    border-top: 1px solid $care-text-color;
    nav {
      ul.footer-menu {
        li {
          &.splitter {
            border-left: 1px solid $care-text-color;
          }
          a {
            color: $care-text-color;
          }
        }
      }
    }
  }
  &.kids_narrative {
    background-color: $kids-bg-color;
    color: $kids-text-color;
    border-top: 1px solid $kids-text-color;
    nav {
      ul.footer-menu {
        li {
          &.splitter {
            border-left: 1px solid $kids-text-color;
          }
          a {
            color: $kids-text-color;
          }
        }
      }
    }
  }
  &.online {
    background-color: $online-bg-color;
    color: $online-main-color;
    border-top: 1px solid $online-main-color;
    nav {
      ul.footer-menu {
        li {
          &.splitter {
            border-left: 1px solid $online-main-color;
          }
          a {
            color: $online-main-color;
          }
        }
      }
    }
  }
}

</style>  